import { Component } from '@angular/core';

@Component({
  selector: 'app-login-footer',
  templateUrl: './login-footer.component.html',
  styleUrls: ['./login-footer.component.css'],
})
export class LoginFooterComponent {
  currentYear = new Date().getFullYear();
}
